import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  ViewEncapsulation,
} from '@angular/core';

import { BspkTouchTarget } from '../touch-target/touch-target.component';
import { BspkIcon } from '../icon';

export type ButtonSize = 'x-small' | 'small' | 'medium' | 'large';
export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
export type ButtonWidth = 'hug' | 'fill';

const buttonDefaults = {
  size: 'medium',
  variant: 'primary',
  width: 'hug',
} as const;

@Component({
  selector: 'button[bspk-button], a[bspk-button]',
  imports: [BspkTouchTarget, BspkIcon],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    '[attr.data-button]': 'true',
    '[attr.data-destructive]': 'destructive() ? true : null',
    '[attr.data-disabled]': 'disabled() ? true : null',
    '[attr.disabled]': 'disabled() ? true : null',
    '[attr.aria-disabled]': 'disabled() ? true : null',
    '[attr.data-size]': 'size()',
    '[attr.data-variant]': 'variant()',
    '[attr.data-width]': 'width()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BspkButton {
  destructive = input(false, { transform: booleanAttribute });
  disabled = input(false, { transform: booleanAttribute });
  size = input<ButtonSize>(buttonDefaults.size);
  variant = input<ButtonVariant>(buttonDefaults.variant);
  width = input<ButtonWidth>(buttonDefaults.width);
  hideLabel = input(false, { transform: booleanAttribute });
  toolTip = input<string>();
  icon = input<string>();
}
